import { usePost } from 'lib/api';
import { apiSuppliers } from 'api/suppliers';
import { useNotification } from 'features/notifications';
import { Response } from 'types';
import { useNavigate } from 'react-router-dom';

export const usePostMergeRequest = (
  supplierId: string,
  mergeRequestId: string | null,
  onSettled: (approved: boolean) => void
) => {
  const { notify } = useNotification();
  const navigate = useNavigate();

  return usePost<{
    id: string;
    action: 'reject' | 'approve';
    mergeRequestId?: string;
    userMappings?: Array<{
      legacyUserId: string;
      selectedRoleId: number;
      designerOrganizationIds: number[];
      action: 'skip' | '';
    }>;
  }>(apiSuppliers.post.mergeRequestAction, false, [supplierId, mergeRequestId || ''], {
    onSuccess: response => {
      const res = response as Response<{ code: string }>;
      if (res?.code === 'legacy_supplier_merge_request_rejected') {
        notify.success({
          id: 'legacy_supplier_merge_request_rejected',
          message: 'legacy_supplier_merge_request_rejected',
          noDuplicate: true,
          isCode: true,
        });
        navigate('/suppliers', { replace: true });
        return;
      }
      if (res?.code === 'legacy_supplier_merge_request_queued') {
        notify.success({
          id: 'legacy_supplier_merge_request_queued',
          message: 'legacy_supplier_merge_request_queued',
          noDuplicate: true,
          isCode: true,
        });
        navigate('/suppliers', { replace: true });
      }
    },
    onSettled: res =>
      onSettled(
        (res as Response<{ code: string }>)?.code === 'legacy_supplier_merge_request_queued'
      ),
  });
};
